module.exports = __webpack_public_path__ + "img/progranPlan2.5d67d518.png";